import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL_All } from '../api';
import axiosInstance from '../axiosInstance';
import AdminLayout from '../components/AdLayout';
import * as general from '../libs/general';
import { toast } from "react-toastify";
import { MedalGold, MedalSilver, MedalBronze } from '../components/tickets/Tickets';


const Databatch = () => {

  const [model, setModel] = useState({});
  const [title, setTitle] = useState('');
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    const fetchPageContents = async () => {
      try {
        var requestApi = `/api/import-orders/getSetting`;
        const response = await axiosInstance.get(requestApi);
        console.log(response.data.data);

        setModel(response.data.data);



      } catch (error) {
        toast.error(error.message, { position: "top-right" });
        console.error("Error fetching :", error);
      }
    };

    fetchPageContents();
  }, [key]);

  const requestServerApi = async (requestApi) => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(requestApi);
      if (!response.data.success) {
        toast.error(response.data.message);
        setIsLoading(false);
        return;
      }

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    }
    setIsLoading(false);
  };

  return (
    <div>
      <AdminLayout>
        <div className="top_nav">
          <div className="nav_menu">
            <div className="nav toggle">
              <a id="menu_toggle"><i className="fa fa-arrow-right"></i><i className="fa fa-arrow-left"></i></a>
            </div>
            <div className="main-header">
              <div className="text-center">THIẾT LẬP XẾP HẠNG</div>
            </div>
          </div>
        </div>
        <div className="right_col" role="main">
          <div className="row">
            <div className="col-md-12 col-sm-12 ">
              <div className="x_panel">
                <div className="x_title">
                  <h2 className="fw-bold">Cài đặt xếp hạng</h2>
                  <ul className="nav navbar-right panel_toolbox">
                  </ul>
                  <div className="clearfix"></div>
                </div>
                <div className="x_content calc-200" data-loading={isLoading}>
                  <form id="form_colors" className="" action="" method="post" noValidate>
                    <div className="table-s table-normal">
                      <table>
                        <tbody>
                          <tr>
                            <th width="50px">STT</th>
                            <th>Action</th>
                            <th>Column 2</th>
                          </tr>
                          <tr>
                            <td>1</td>
                            <td className="cell-normal">
                              <button type='button' className="m-1 btn btn-primary btn-sm" onClick={() => requestServerApi('/api/databatch/updateFeesIfNull')}>UpdateFeesIfNull</button>
                            </td>                  
                            <td className="cell-normal">
                              <button type='button' className="m-1 btn btn-primary btn-sm" onClick={() => requestServerApi('/api/databatch/fixOrderCodeCn')}>fixOrderCodeCn</button></td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td className="cell-normal">
                              <button type='button' className="m-1 btn btn-primary btn-sm" onClick={() => requestServerApi('/api/invoices/generateListInvoices')}>Generate reports</button>
                            </td>
                            <td className="cell-normal">
                              <button type='button' className="m-1 btn btn-primary btn-sm" onClick={() => requestServerApi('/api/databatch/fixData?keyword=KH191')}>Fix KH 191</button>
                              
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td className="cell-normal">
                              <button type='button' className="m-1 btn btn-primary btn-sm" onClick={() => requestServerApi('/api/databatch/caculateRankingForAllUsers')}>caculateRankingForAllUsers</button>
                            </td>
                            <td className="cell-normal">
                              <button type='button' className="m-1 btn btn-primary btn-sm" onClick={() => requestServerApi('/api/invoices/resetAllContactingId')}>Reset all contactingId</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </form>
                </div>
              </div>
            </div>


          </div>
        </div>
        <footer className="d-none"> </footer>
      </AdminLayout>
    </div>
  );
};

export default Databatch;